import { ApexOptions } from 'apexcharts';

import { CHART_COLORS } from '../shared/chart-colors';
import { buildChartPointTooltipHtml } from '../shared/chart-tooltip';
import { formatAxisLabel } from '../shared/format-axis-label';

export interface BarChartOptionsConfig {
    categories: string[];
    stacked?: boolean;
    showLegend?: boolean;
    height: number;
    width?: number;
    colors?: string[];
}

export const getBarChartOptions = (config: BarChartOptionsConfig): ApexOptions => {
    const { categories, stacked = false, showLegend = stacked, height, width, colors = [...CHART_COLORS] } = config;

    return {
        chart: {
            height,
            width: width || '100%',
            type: 'bar',
            stacked,
            parentHeightOffset: 0,
            toolbar: {
                show: false
            },
            animations: {
                enabled: true
            }
        },
        dataLabels: {
            enabled: false
        },
        colors,
        grid: {
            show: false,
            padding: {
                left: 8,
                right: 8,
                bottom: 0
            }
        },
        xaxis: {
            categories,
            axisTicks: {
                show: false
            },
            axisBorder: {
                show: false
            },
            labels: {
                show: true,
                rotate: 0,
                hideOverlappingLabels: true,
                trim: false,
                maxHeight: 48,
                style: {
                    cssClass: 'apexcharts-xaxis-label fill-foreground-default'
                },
                formatter: (value) => formatAxisLabel(String(value))
            },
            tooltip: {
                formatter: (value) => formatAxisLabel(String(value))
            }
        },
        yaxis: {
            labels: {
                style: {
                    colors: ['var(--color-foreground-default)']
                }
            }
        },
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: '85%',
                borderRadius: 4,
                borderRadiusWhenStacked: 'last'
            }
        },
        legend: {
            show: showLegend,
            position: 'top',
            horizontalAlign: 'left',
            onItemHover: {
                highlightDataSeries: true
            },
            labels: {
                colors: 'var(--color-foreground-default)'
            }
        },
        tooltip: {
            custom: (context) => {
                const label = categories[context.dataPointIndex] ?? context.w.globals.labels[context.dataPointIndex] ?? '';
                const value = context.w.globals.series[context.seriesIndex][context.dataPointIndex];
                const seriesName = context.w.config.series[context.seriesIndex]?.name || undefined;

                return buildChartPointTooltipHtml(label, value, seriesName);
            }
        }
    };
};
